module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Pedidos y logística":"Pedidos y logística","Hola":"Hola","Tiempo restante para que caduque su sesión":"Tiempo restante para que caduque su sesión"},"en":{"Pedidos y logística":"Orders and logistics","Hola":"Hi","Tiempo restante para que caduque su sesión":"Time remaining for your session to expire"}}')
  delete Component.options._Ctor
}
